import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { getRequestWithToken } from "../../utils/ApiRequests";
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import { Alert, Box, Button, Card, CardContent, Chip, Container, Grid, MenuItem, Stack, TextField, Typography } from '@mui/material';
import { GlobalContext } from '../../components/GlobalStateProvide/GlobalStateProvider';
import "./employer.scss";
import BackBtn from '../../components/backButton/BackBtn';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  MaterialReactTable,
  useMaterialReactTable
} from 'material-react-table';


import { checkPermission } from "../../utils/userPermissions";
import Unauthorized from "../../components/unauthorized/Unauthorized";

const EmployerDetails = () => {
  const { employerId } = useParams();
  const [searchParams] = useSearchParams();
  const u = searchParams.get("u");
  const [employerData, setEmployerData] = useState([]);
  const [employerTransactionsData, setEmployerTransactionsData] = useState([]);
  const [employerPostedJobsData, setEmployerPostedJobsData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const { handleSnackBar } = useContext(GlobalContext);
  const location = useLocation();

  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);

  const [columnFilters2, setColumnFilters2] = useState([]);
  const [globalFilter2, setGlobalFilter2] = useState("");
  const [sorting2, setSorting2] = useState([]);
  const [isRefetching2, setIsRefetching2] = useState(false);
  const [isError2, setIsError2] = useState(false);

  const [rowCount, setRowCount] = useState(0);
  const [rowCount2, setRowCount2] = useState(0);
  const [loadingDataInTranxTable, setLoadingDataInTranxTable] = useState(null);
  const [loadingDataInJobsTable, setLoadingDataInJobsTable] = useState(null);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [pagination2, setPagination2] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [canCreate, setCanCreate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canRead, setCanRead] = useState(false);

  const [isAccess, setisAccess] = useState([]);
  const [isIncludesValue, setisIncludesValue] = useState(null);

  // SNF tab state
  const [snfData, setSnfData] = useState(null);
  const [snfLoading, setSnfLoading] = useState(false);
  const [snfError, setSnfError] = useState("");
  const [snfPage, setSnfPage] = useState(1);
  const [snfPageSize, setSnfPageSize] = useState(10);
  const [snfStartDate, setSnfStartDate] = useState("2026-01-01");
  const [snfEndDate, setSnfEndDate] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  });
  const [snfStartDateInput, setSnfStartDateInput] = useState("2026-01-01");
  const [snfEndDateInput, setSnfEndDateInput] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  });
  const [snfFilterError, setSnfFilterError] = useState("");

  // SNF Purchase History separate state
  const [snfPurchaseData, setSnfPurchaseData] = useState([]);
  const [snfPurchaseLoading, setSnfPurchaseLoading] = useState(false);
  const [snfPurchaseError, setSnfPurchaseError] = useState("");
  const [snfPurchasePage, setSnfPurchasePage] = useState(1);
  const [snfPurchasePageSize, setSnfPurchasePageSize] = useState(10);
  const [snfPurchaseStatus, setSnfPurchaseStatus] = useState("purchased");
  const [snfPurchasePagination, setSnfPurchasePagination] = useState({ page: 1, limit: 10, total: 0, pages: 1 });

  const columns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowIndex = row.index;
        return <span>{rowIndex + 1 + pageIndex * pageSize}</span>;
      },
    },
    { accessorKey: "merchantTransactionId", size: 250, header: "Transaction ID" },
    { accessorKey: "merchantId", size: 170, header: "Merchant ID" },
    {
      accessorKey: "paymentDate", size: 220, header: "Transaction Date",
      enableColumnFilter: false,
      Cell: ({ cell }) => (cell.getValue() ?
        <span>
          {new Date(cell.getValue()).toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
          })}
        </span> : '--'
      ),
    },
    { accessorKey: "planType", header: "Transaction Type", enableColumnFilter: false, },
    { accessorKey: "paymentMode", size: 180, header: "Mode of Payment", enableColumnFilter: false, },
    { accessorKey: "amount", size: 150, header: "Amount", enableColumnFilter: false, },
    { accessorKey: "creditType", size: 120, header: "Type", enableColumnFilter: false, },
    { accessorKey: "creditCount", size: 150, header: "Credits", enableColumnFilter: false, },
    { accessorKey: "state", header: "Payment Status", enableColumnFilter: false, },
    { accessorKey: "comment", header: "Reason", enableColumnFilter: false, },
    { accessorKey: "systemMessage", header: "System Message", enableColumnFilter: false, },
    {
      accessorKey: "doewnloadInvoice",
      header: "Action",
      size: 200,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <div style={{ textTransform: "uppercase" }}>
          {row?.original?.invoiceLink && <Button style={{ textTransform: "capitalize" }} onClick={() => handleDownloadInvoice(row?.original?.invoiceLink)}>View/Download Invoice</Button>}
        </div>
      ),
    },
  ];

  const handleDownloadInvoice = (invoiceLink) => {
    if (invoiceLink) {
      window.open(invoiceLink, '_blank');
    } else {
      handleSnackBar(true, "Invoice link not available", "error");
    }
  };


  const jobDataColumns = [
    {
      accessorKey: "id",
      header: "S.No.",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ row, table }) => {
        const pageIndex = table.getState().pagination.pageIndex;
        const pageSize = table.getState().pagination.pageSize;
        const rowIndex = row.index;
        return <span>{rowIndex + 1 + pageIndex * pageSize}</span>;
      },
    },
    {
      accessorKey: "jobId",
      header: "Job ID",
      Cell: ({ row }) => (
        <a
          href={`/posted-jobs/${row?.original?._id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
          style={{ cursor: canRead ? 'pointer' : 'not-allowed' }}
          onClick={(e) => !canRead && e.preventDefault()}
        >
          {row.original.jobId}
        </a>
      ),
    },
    { accessorKey: "jobRoleNameEn", id: 'jobRole', header: "Job Role" },
    {
      accessorKey: "jobLiveAt",
      enableColumnFilter: false,
      Cell: ({ cell }) => (cell.getValue() ?
        <span>
          {new Date(cell.getValue()).toLocaleString("en-US", {
            timeZone: "Asia/Kolkata",
          })}
        </span> : '--'
      ), header: "Date Posted"
    },
    {
      accessorKey: "city",
      header: "Location",
      enableColumnFilter: false,
      accessorFn: (row) => {
        let { city, state } = row.jobDescription?.jobLocation || {};
        return (
          [city, state].filter(Boolean).join(", ")
        )
        // row.jobDescription?.jobLocation.state ?? "---"},
      }
    },
    {
      accessorKey: "status",
      enableColumnFilter: false,
      accessorFn: (row) => {
        if (row?.deleted?.isDeleted) return "Deleted";
        if (row?.isArchived) return "Archived";
        if (row?.isDraft) return "Draft";
        if (row?.isActive) return "Active";
        if (row?.isAdminApprovalNeed) return "Admin Approval Needed";
        if (row?.isRejectedByAdmin) return "Rejected By Admin";
        return "Unknown";
      },
      header: "Status"
    },
  ];

  const getEmployerDetails = async () => {
    try {
      let response = await getRequestWithToken(`admin/userbyid?usertype=employer&userid=${employerId}`);
      setEmployerData(response.data.data);
      // console.log("response : " + JSON.stringify(response.data.data))
      setShowLoader(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setShowLoader(false);
    }
  };

  const getEmployerTransactionsDetails = async () => {
    setLoadingDataInTranxTable(true);
    try {

      const filterParams = {
        // global: globalFilter,
        ...Object.fromEntries(
          columnFilters.map((filter) => [filter.id, filter.value])
        ),
      };
      const filterQueryString = new URLSearchParams(filterParams).toString();

      let response = await getRequestWithToken(`admin/employer/transaction?page=${pagination.pageIndex + 1}&limit=${pagination.pageSize}&employerId=${employerId}&${filterQueryString}`);
      setEmployerTransactionsData(response.data.data);
      setRowCount(response?.data?.totalCount);
      // console.log("response : " + JSON.stringify(response.data.data))
      setLoadingDataInTranxTable(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setLoadingDataInTranxTable(false);
    }
  };

  const getEmployerPostedJobsDetails = async () => {
    setLoadingDataInJobsTable(true);
    try {

      const filterParams = {
        // global: globalFilter,
        ...Object.fromEntries(
          columnFilters2.map((filter) => [filter.id, filter.value])
        ),
      };
      const filterQueryString2 = new URLSearchParams(filterParams).toString();

      let response = await getRequestWithToken(`admin/employer/jobs?page=${pagination2.pageIndex + 1}&limit=${pagination2.pageSize}&employerId=${employerId}&${filterQueryString2}`);
      setEmployerPostedJobsData(response.data.data);
      setRowCount2(response?.data?.totalCount);
      // console.log("response : " + JSON.stringify(response.data.data))
      setLoadingDataInJobsTable(false);
    } catch (error) {
      handleSnackBar(true, error?.response?.data?.message || error?.message, "error");
      setLoadingDataInJobsTable(false);
    }
  };

  useEffect(() => {

    getEmployerDetails();
  }, [employerId
  ]);


  useEffect(() => {
    getEmployerTransactionsDetails();
  }, [employerId,
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  useEffect(() => {
    getEmployerPostedJobsDetails();
  }, [employerId,
    columnFilters2,
    globalFilter2,
    pagination2.pageIndex,
    pagination2.pageSize,
    sorting2,
  ]);



  useEffect(() => {
    // console.log("data response: ", JSON.stringify(employerData));
  }, [employerData]);

  const fetchSnfData = async () => {
    try {
      setSnfLoading(true);
      setSnfError("");
      const response = await getRequestWithToken(
        `snf-admin/employers/${employerId}?page=${snfPage}&limit=${snfPageSize}&startDate=${snfStartDate}&endDate=${snfEndDate}`
      );
      setSnfData(response?.data?.data || null);
    } catch (error) {
      setSnfError(error?.response?.data?.msg || "Unable to load SNF data.");
    } finally {
      setSnfLoading(false);
    }
  };

  const handleSnfFilterApply = () => {
    if (!snfStartDateInput || !snfEndDateInput) {
      setSnfFilterError("Please select both start date and end date.");
      return;
    }
    if (new Date(snfStartDateInput) > new Date(snfEndDateInput)) {
      setSnfFilterError("Start date cannot be after end date.");
      return;
    }
    setSnfFilterError("");
    setSnfPage(1);
    setSnfStartDate(snfStartDateInput);
    setSnfEndDate(snfEndDateInput);
  };

  useEffect(() => {
    fetchSnfData();
  }, [employerId, snfPage, snfPageSize, snfStartDate, snfEndDate]);

  const fetchSnfPurchaseData = async () => {
    try {
      setSnfPurchaseLoading(true);
      setSnfPurchaseError("");
      const query = new URLSearchParams();
      query.set("page", snfPurchasePage);
      query.set("limit", snfPurchasePageSize);
      query.set("startDate", snfStartDate);
      query.set("endDate", snfEndDate);
      if (snfPurchaseStatus) query.set("status", snfPurchaseStatus);
      const response = await getRequestWithToken(
        `snf-admin/employers/${employerId}?${query.toString()}`
      );
      setSnfPurchaseData(response?.data?.data?.sessions || []);
      setSnfPurchasePagination(response?.data?.data?.pagination || { page: 1, limit: 10, total: 0, pages: 1 });
    } catch (error) {
      setSnfPurchaseError(error?.response?.data?.msg || "Unable to load SNF purchase data.");
    } finally {
      setSnfPurchaseLoading(false);
    }
  };

  useEffect(() => {
    fetchSnfPurchaseData();
  }, [employerId, snfPurchasePage, snfPurchasePageSize, snfPurchaseStatus, snfStartDate, snfEndDate]);

  const table = useMaterialReactTable({
    columns,
    data: employerTransactionsData,

    initialState: { showColumnFilters: false },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    // enableColumnFilters: false,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      style: {
        backgroundColor: "#ff671f", // Custom orange color
      },
    },
    muiCircularProgressProps: {
      color: "secondary",
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading: loadingDataInTranxTable,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount / pageSize);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    renderTopToolbarCustomActions: ({ table }) => {
      const pinnedColumns = table.getState().columnPinning;
      return (
        <Box>
          <Chip
            label={`Left Pinned: ${pinnedColumns.left.length}`}
            color="primary"
            sx={{ mr: 1 }}
          />
          <Chip
            label={`Right Pinned: ${pinnedColumns.right.length}`}
            color="secondary"
          />
        </Box>
      );
    },
  });


  const jobTable = useMaterialReactTable({
    columns: jobDataColumns,
    data: employerPostedJobsData,

    initialState: { showColumnFilters: false },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnPinning: true,
    enableColumnResizing: true,
    enableGlobalFilter: false,
    enableColumnFilters: true,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      style: {
        backgroundColor: "#ff671f", // Custom orange color
      },
    },
    muiCircularProgressProps: {
      color: "secondary",
    },
    muiToolbarAlertBannerProps: isError
      ? {
        color: "error",
        children: "No Data",
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters2,
    onGlobalFilterChange: setGlobalFilter2,
    onPaginationChange: setPagination2,
    onSortingChange: setSorting2,
    rowCount: rowCount2,
    state: {
      columnFilters2,
      globalFilter2,
      isLoading: loadingDataInJobsTable,
      pagination: pagination2,
      showAlertBanner: isError2,
      showProgressBars: isRefetching2,
      sorting2,
    },
    renderBottomToolbarCustomActions: ({ table }) => {
      const { pageIndex, pageSize } = table.getState().pagination;
      const totalPages = Math.ceil(rowCount2 / pageSize);
      return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" style={{ marginLeft: "10px" }}>
            Page {pageIndex + 1} of {totalPages}
          </Typography>
        </Box>
      );
    },
    // renderTopToolbarCustomActions: ({ table }) => {
    //   const pinnedColumns = table.getState().columnPinning;
    //   return (
    //     <Box>
    //       <Chip
    //         label={`Left Pinned: ${pinnedColumns.left.length}`}
    //         color="primary"
    //         sx={{ mr: 1 }}
    //       />
    //       <Chip
    //         label={`Right Pinned: ${pinnedColumns.right.length}`}
    //         color="secondary"
    //       />
    //     </Box>
    //   );
    // },
  });

  const snfSessionColumns = [
    {
      accessorKey: "sessionId",
      header: "Session ID",
      size: 160,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        return <Typography variant="caption" sx={{ fontFamily: "monospace", fontSize: "0.7rem" }}>{val ? `...${val.slice(-8)}` : "-"}</Typography>;
      },
    },
    {
      accessorKey: "roleName",
      header: "Role",
      size: 210,
      enableColumnFilter: false,
      Cell: ({ cell }) => <Typography variant="body2" sx={{ whiteSpace: "normal", wordBreak: "break-word" }}>{cell.getValue() || "-"}</Typography>,
    },
    {
      accessorKey: "sessionStatus",
      header: "Status",
      size: 120,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        const styleMap = {
          purchased: { backgroundColor: "rgba(76,175,80,0.12)", color: "#2e7d32" },
          abandoned: { backgroundColor: "rgba(244,67,54,0.12)", color: "#b71c1c" },
          analyzed: { backgroundColor: "rgba(33,150,243,0.12)", color: "#0a5c99" },
        };
        const sx = styleMap[val] || { backgroundColor: "rgba(0,0,0,0.08)", color: "#555" };
        return <Chip label={val || "-"} size="small" sx={{ ...sx, fontWeight: 600, textTransform: "capitalize", border: "none" }} />;
      },
    },
    {
      accessorKey: "quantityRequested",
      header: "Qty Requested",
      size: 120,
      enableColumnFilter: false,
    },
    {
      id: "totalCandidatesFound",
      header: "Candidates Found",
      size: 140,
      enableColumnFilter: false,
      accessorFn: (row) => row.analysisResults?.totalCandidatesFound ?? "-",
    },
    {
      id: "responseProbability",
      header: "Response",
      size: 100,
      enableColumnFilter: false,
      accessorFn: (row) => row.analysisResults?.responseProbability,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        const colorMap = { high: "#2e7d32", medium: "#bf6000", low: "#b71c1c" };
        return val ? (
          <Typography variant="body2" sx={{ color: colorMap[val] || "inherit", textTransform: "capitalize", fontWeight: 600 }}>{val}</Typography>
        ) : "-";
      },
    },
    {
      accessorKey: "reminderSent",
      header: "Reminder",
      size: 90,
      enableColumnFilter: false,
      Cell: ({ cell }) => cell.getValue()
        ? <Chip label="Sent" size="small" sx={{ backgroundColor: "rgba(76,175,80,0.12)", color: "#2e7d32", border: "none" }} />
        : <Chip label="No" size="small" sx={{ backgroundColor: "rgba(0,0,0,0.06)", color: "#666", border: "none" }} />,
    },
    {
      accessorKey: "createdAt",
      header: "Created At",
      size: 130,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        if (!val) return "-";
        return new Date(val).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
      },
    },
  ];

  const snfPurchaseColumns = [
    {
      accessorKey: "sessionId",
      header: "Session ID",
      size: 160,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        return <Typography variant="caption" sx={{ fontFamily: "monospace", fontSize: "0.7rem" }}>{val ? `...${val.slice(-8)}` : "-"}</Typography>;
      },
    },
    {
      accessorKey: "roleName",
      header: "Role",
      size: 210,
      enableColumnFilter: false,
      Cell: ({ cell }) => <Typography variant="body2" sx={{ whiteSpace: "normal", wordBreak: "break-word" }}>{cell.getValue() || "-"}</Typography>,
    },
    {
      id: "quantityCharged",
      header: "Qty Charged",
      size: 110,
      enableColumnFilter: false,
      accessorFn: (row) => row.pricingBreakdown?.quantityCharged ?? "-",
    },
    {
      id: "phcPerCandidate",
      header: "PHC / Candidate",
      size: 120,
      enableColumnFilter: false,
      accessorFn: (row) => row.pricingBreakdown?.phcPerCandidate ?? "-",
    },
    {
      id: "totalPhc",
      header: "Total PHC",
      size: 110,
      enableColumnFilter: false,
      accessorFn: (row) => {
        const val = row.pricingBreakdown?.totalPhc;
        return val != null ? Number(val).toLocaleString() : "-";
      },
    },
    {
      id: "totalInr",
      header: "Total INR",
      size: 110,
      enableColumnFilter: false,
      accessorFn: (row) => {
        const val = row.pricingBreakdown?.totalInr;
        return val != null ? `₹${Number(val).toLocaleString()}` : "-";
      },
    },
    {
      accessorKey: "purchasedAt",
      header: "Purchased At",
      size: 140,
      enableColumnFilter: false,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        if (!val) return "-";
        return new Date(val).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
      },
    },
  ];

  const snfSessionTable = useMaterialReactTable({
    columns: snfSessionColumns,
    data: snfData?.sessions || [],
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    layoutMode: "grid",
    state: { isLoading: snfLoading },
    initialState: { density: "compact" },
    muiTableBodyCellProps: { sx: { borderBottom: "1px solid rgba(0,0,0,0.07)" } },
    muiTableContainerProps: { sx: { maxHeight: "420px" } },
  });

  const snfPurchaseTable = useMaterialReactTable({
    columns: snfPurchaseColumns,
    data: snfPurchaseData,
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: false,
    layoutMode: "grid",
    state: { isLoading: snfLoading },
    initialState: { density: "compact" },
    muiTableBodyCellProps: { sx: { borderBottom: "1px solid rgba(0,0,0,0.07)" } },
    muiTableContainerProps: { sx: { maxHeight: "420px" } },
  });

  const checkPermissionFunc = () => {
    const resourceToUpdate = u === "employer" ? "Employer" : "Recruiter";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate);
    setCanDelete(permissions.canDelete);
    setCanUpdate(permissions.canUpdate);
    setCanRead(permissions.canRead);
  };

  const againCheckPermissions = () => {
    const checkAccesInArray = localStorage.getItem("resourceNames");
    setisAccess(checkAccesInArray);
    isIncludes();
  };

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes(u === "employer" ? "Employer" : "Recruiter"));
  };

  useEffect(() => {
    // getAllJobs();
    checkPermissionFunc();
    againCheckPermissions();
  }, [isIncludesValue]);

  return isIncludesValue ? (
    (showLoader) ? <ReusableLoader /> :
      <Box className="create-candidates-section">

        <Container>

          <Box className="create-candidates">
            <Box className="headingPlusBackBtn">
              {/* <BackBtn /> */}
              <h1 className='formHeadings' style={{ textTransform: 'capitalize' }} id="topEle" >{u} Details</h1>
            </Box>
            <Box className="create-candidates-form-wrapper">

              <Box>
                <Accordion defaultExpanded>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                  >
                    <Typography variant="h7" component="h4">Personal Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box className="backgroundStyle">
                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>
                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'> First Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.firstName ? employerData?.firstName : '--'}</Typography>
                            </Box>
                          </Grid>

                          {/* <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'> Middle Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.middleName ? employerData?.middleName : '--'}</Typography>
                            </Box>
                          </Grid> */}

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >Last Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.lastName ? employerData?.lastName : '--'}</Typography>
                            </Box>
                          </Grid>

                        </Grid>
                      </Box>

                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>
                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'>Mobile Number</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.phone ? employerData?.phone : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'>Email Address</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.email ? employerData?.email : '--'}</Typography>
                            </Box>
                          </Grid>

                        </Grid>
                      </Box>

                      <Box className='marginBottom10'>

                        <Grid container spacing={2} className='cstmFormGridEmployer'>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5'  >Company Name</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }} >{employerData?.companyName ? employerData?.companyName : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' > Address</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.fullAddress ? employerData?.companyAddress?.fullAddress : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' > Pincode</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.pincode ? employerData?.companyAddress?.pincode : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >City</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.city ? employerData?.companyAddress?.city : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >State</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.state ? employerData?.companyAddress?.state : '--'}</Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >Recruitment Agency</Typography>
                              <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.recruitmentAgency ? "Yes" : 'No'}</Typography>
                            </Box>
                          </Grid>
                        </Grid>

                        {employerData?.businessLogo && <Grid container spacing={2} className='cstmFormGridEmployer' style={{ marginTop: '5px' }}>

                          <Grid item xs={12} sm={6} md={4}>
                            <Box className="form-control">
                              <Typography variant="h7" component='h5' >BusinessLogo</Typography>
                              {/* <Typography variant="subtitle2" style={{ paddingLeft: "5px" }}>{employerData?.companyAddress?.state}</Typography> */}
                              <img src={employerData?.businessLogo} width={250} style={{ borderRadius: "10px" }} alt="" />
                            </Box>
                          </Grid>

                        </Grid>}
                      </Box>
                    </Box>

                    <Box className="backgroundStyle">
                      <Grid container spacing={2} className='cstmFormGridEmployer'>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <Typography variant="h7" component='h5'> PHC</Typography>
                            <Typography variant="subtitle2" style={{ paddingLeft: "5px", backgroundColor: "#e1f5fe", color: "#0277bd", fontWeight: "600" }} >{employerData?.plusHiringCredits?.availablePHC ? employerData?.plusHiringCredits?.availablePHC : '--'}</Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <Box className="form-control">
                            <Typography variant="h7" component='h5'> HC</Typography>
                            <Typography variant="subtitle2" style={{ paddingLeft: "5px", backgroundColor: "#f3e5f5", color: "#6a1b9a", fontWeight: "600" }} >{employerData?.hiringCredits?.remainingHiringCredit ? employerData?.hiringCredits?.remainingHiringCredit : '--'}</Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h7" component="h4">Transaction Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>

                    <MaterialReactTable
                      table={table}
                    />
                  </AccordionDetails>
                </Accordion>

                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                  >
                    <Typography variant="h7" component="h4">Posted Jobs Details</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <MaterialReactTable
                      table={jobTable}
                    />
                  </AccordionDetails>
                </Accordion>

                {/* SNF Section - Session-wise Data */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-snf-session-content"
                    id="panel-snf-session-header"
                  >
                    <Typography variant="h7" component="h4">SNF - Session-wise Data</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ p: 2 }}>
                      {/* Summary cards */}
                      {snfData?.summary && (
                        <Grid container spacing={2} sx={{ mb: 2 }}>
                          {[
                            { label: "Total Sessions", value: snfData.summary.totalSessions },
                            { label: "Purchased", value: snfData.summary.purchasedSessions },
                            { label: "Abandoned", value: snfData.summary.abandonedSessions },
                            { label: "PHC Spent", value: Number(snfData.summary.totalPhcSpent).toLocaleString() },
                            { label: "INR Spent", value: `₹${Number(snfData.summary.totalInrSpent).toLocaleString()}` },
                          ].map((item) => (
                            <Grid item xs={6} sm={4} md={2} key={item.label}>
                              <Card variant="outlined" sx={{ textAlign: "center", background: "rgba(25,118,210,0.03)" }}>
                                <CardContent sx={{ py: 1, "&:last-child": { pb: 1 } }}>
                                  <Typography variant="h6" sx={{ fontWeight: 700 }}>{item.value}</Typography>
                                  <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                                </CardContent>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      )}

                      {/* Date filter */}
                      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center" sx={{ mb: 2 }}>
                        <TextField
                          label="Start Date" type="date" size="small"
                          value={snfStartDateInput}
                          onChange={(e) => setSnfStartDateInput(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                          label="End Date" type="date" size="small"
                          value={snfEndDateInput}
                          onChange={(e) => setSnfEndDateInput(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                        />
                        <Button variant="contained" size="small" disabled={snfLoading} onClick={handleSnfFilterApply}>
                          {snfLoading ? "Loading..." : "Apply"}
                        </Button>
                      </Stack>

                      {snfFilterError ? <Alert severity="warning" sx={{ mb: 1 }}>{snfFilterError}</Alert> : null}
                      {snfError ? <Alert severity="error" sx={{ mb: 1 }}>{snfError}</Alert> : null}

                      <MaterialReactTable table={snfSessionTable} />

                      {/* Pagination */}
                      <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end" sx={{ mt: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          {snfData?.pagination?.total > 0
                            ? `Page ${snfData.pagination.page} of ${snfData.pagination.pages} (${snfData.pagination.total} total)`
                            : "No results"}
                        </Typography>
                        <TextField
                          label="Rows" size="small" select
                          value={snfPageSize}
                          onChange={(e) => { setSnfPageSize(Number(e.target.value)); setSnfPage(1); }}
                          sx={{ width: 80 }}
                        >
                          {[10, 20, 50].map((n) => <MenuItem key={n} value={n}>{n}</MenuItem>)}
                        </TextField>
                        <Button size="small" variant="outlined" disabled={snfPage <= 1 || snfLoading} onClick={() => setSnfPage((p) => p - 1)}>Prev</Button>
                        <Button size="small" variant="outlined" disabled={snfPage >= (snfData?.pagination?.pages || 1) || snfLoading} onClick={() => setSnfPage((p) => p + 1)}>Next</Button>
                      </Stack>
                    </Box>
                  </AccordionDetails>
                </Accordion>

                {/* SNF Section - Purchase History */}
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-snf-purchase-content"
                    id="panel-snf-purchase-header"
                  >
                    <Typography variant="h7" component="h4">SNF - Purchase History</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box sx={{ p: 2 }}>
                      {/* Status filter */}
                      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center" sx={{ mb: 2 }}>
                        <TextField
                          label="Status" size="small" select
                          value={snfPurchaseStatus}
                          onChange={(e) => { setSnfPurchaseStatus(e.target.value); setSnfPurchasePage(1); }}
                          sx={{ minWidth: 160 }}
                        >
                          <MenuItem value="">All</MenuItem>
                          <MenuItem value="purchased">Purchased</MenuItem>
                          <MenuItem value="analyzed">Analyzed</MenuItem>
                          <MenuItem value="abandoned">Abandoned</MenuItem>
                        </TextField>
                      </Stack>

                      {snfPurchaseError ? <Alert severity="error" sx={{ mb: 1 }}>{snfPurchaseError}</Alert> : null}
                      {!snfPurchaseLoading && snfPurchaseData.length === 0 ? (
                        <Typography variant="body2" color="text.secondary">No sessions found for the selected filters.</Typography>
                      ) : (
                        <MaterialReactTable table={snfPurchaseTable} />
                      )}

                      {/* Pagination */}
                      <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-end" sx={{ mt: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          {snfPurchasePagination.total > 0
                            ? `Page ${snfPurchasePagination.page} of ${snfPurchasePagination.pages} (${snfPurchasePagination.total} total)`
                            : "No results"}
                        </Typography>
                        <TextField
                          label="Rows" size="small" select
                          value={snfPurchasePageSize}
                          onChange={(e) => { setSnfPurchasePageSize(Number(e.target.value)); setSnfPurchasePage(1); }}
                          sx={{ width: 80 }}
                        >
                          {[10, 20, 50].map((n) => <MenuItem key={n} value={n}>{n}</MenuItem>)}
                        </TextField>
                        <Button size="small" variant="outlined" disabled={snfPurchasePage <= 1 || snfPurchaseLoading} onClick={() => setSnfPurchasePage((p) => p - 1)}>Prev</Button>
                        <Button size="small" variant="outlined" disabled={snfPurchasePage >= snfPurchasePagination.pages || snfPurchaseLoading} onClick={() => setSnfPurchasePage((p) => p + 1)}>Next</Button>
                      </Stack>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Box>

            </Box>
          </Box>
        </Container>

      </Box >) : <Unauthorized />;
};

export default EmployerDetails;
